import { useState, useEffect } from "react";
import LoaderIcon from "@/assets/icons/loader.svg?react";
import "./styles/Loader.scss";

type Props = {
  text?: string;
  extraTexts?: string[];
  textInterval?: number;
  horizontalAlign?:  `left` | `center` | `right`;
  overlay?: boolean;
  delay?: number;
}

const Loader = ({ text = ``, extraTexts = [], textInterval = 4, overlay = false, horizontalAlign = `center`, delay = 250 }: Props) => {
  const [visible, setVisible] = useState(false);
  const [textIndex, setTextIndex] = useState(0);
  const texts = [text, ...extraTexts].filter(Boolean);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // Cycle through the extra texts while loading takes longer than expected.
  useEffect(() => {
    setTextIndex(0);
    if (texts.length <= 1) {
      return;
    }
    const interval = setInterval(() => {
      setTextIndex(previousIndex => (previousIndex + 1) % texts.length);
    }, textInterval * 1000);
    return () => clearInterval(interval);
  }, [text, extraTexts.join(`|`), textInterval]);

  const classes = [
    `ws-loader-wrapper`,
    `ws-loader-wrapper--align-` + horizontalAlign,
    visible ? `ws-loader-wrapper--visible` : ``,
  ];

  const iconClasses = [
    `ws-loader-icon`,
    overlay ? `ws-loader-icon--overlay` : ``,
  ];

  const textClasses = [
    `ws-loader-text`,
    `ws-loader__text`,
  ];

  return (
    <div className={ classes.join(` `) }>
      <div className={ iconClasses.join(` `) }>
        <LoaderIcon/>
      </div>
      { texts.length > 0 &&
        <div className={ textClasses.join(` `) }>
          { texts[textIndex] }
        </div>
      }
    </div>
  )
}



export default Loader;
